import React from "react";

import type {
  ListingInferenceReviewPortalPhase,
  ListingInferenceReviewPortalStatusMessage,
} from "@view/listing/inference/reviewPortal/ListingInferenceReviewPortalPhase";

type ListingInferenceReviewPortalUnavailableProps = {
  readonly hasProvider: boolean;
  readonly hasProgramBoundary: boolean;
  readonly listingId: string;
  readonly phase: ListingInferenceReviewPortalPhase;
  readonly statusMessages: readonly ListingInferenceReviewPortalStatusMessage[];
  readonly unavailableMessage: string;
};

const ListingInferenceReviewPortalUnavailable: React.FC<ListingInferenceReviewPortalUnavailableProps> = ({
  hasProvider,
  hasProgramBoundary,
  listingId,
  phase,
  statusMessages,
  unavailableMessage,
}) => {
  const providerStatus = hasProvider ? "mounted" : "missing";
  const programStatus = hasProgramBoundary ? "available" : "missing";

  return (
    <section aria-label="Listing inference review portal" data-testid="listing-inference-review-portal-hidden">
      <h1>Listing inference review</h1>
      <p>{unavailableMessage}</p>
      {statusMessages.map((message) => (
        <p key={message.id} role="alert" data-testid="listing-inference-review-portal-error">
          {message.message}
        </p>
      ))}
      <dl>
        <dt>Phase</dt>
        <dd data-testid="listing-inference-review-portal-phase">{phase}</dd>
        <dt>Listing</dt>
        <dd data-testid="listing-inference-review-portal-listing">{listingId}</dd>
        <dt>Provider</dt>
        <dd data-testid="listing-inference-review-portal-provider">{providerStatus}</dd>
        <dt>Program</dt>
        <dd data-testid="listing-inference-review-portal-program">{programStatus}</dd>
      </dl>
    </section>
  );
};

export default ListingInferenceReviewPortalUnavailable;
